import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { Table } from 'src/design/molecules/Table';
import React, { useId } from 'react';
import { AdminReasoningEffortStatsDto } from 'src/api/FiretrolApiClient';
import { reasoningEffortLabel } from 'src/routes/Settings/AIAssistant/replyUsage';
import { formatCurrency, formatNumber } from 'src/utils';

export interface IReasoningEffortTableProps {
  rows: AdminReasoningEffortStatsDto[];
}

export const ReasoningEffortTable: React.FC<IReasoningEffortTableProps> = ({
  rows,
}) => {
  const titleId = useId();

  return (
    <Stack gap="xs">
      <Text id={titleId} size="xs" fw={600} tt="uppercase" c="gray.7">
        By reasoning effort
      </Text>
      <Table.ScrollContainer minWidth={480}>
        <Table aria-labelledby={titleId} fz="sm" verticalSpacing={4}>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Effort</Table.Th>
              <Table.Th ta="right">Replies</Table.Th>
              <Table.Th ta="right">Output tokens</Table.Th>
              <Table.Th ta="right">Of which reasoning</Table.Th>
              <Table.Th ta="right">Est. cost</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {rows.map((row) => (
              <Table.Tr key={row.reasoningEffort ?? ''}>
                <Table.Td c={row.reasoningEffort ? 'bright' : 'dimmed'}>
                  {reasoningEffortLabel(row.reasoningEffort)}
                </Table.Td>
                <Table.Td ta="right">{formatNumber(row.messageCount)}</Table.Td>
                <Table.Td ta="right">{formatNumber(row.outputTokens)}</Table.Td>
                <Table.Td ta="right">
                  {formatNumber(row.reasoningTokens)}
                </Table.Td>
                <Table.Td ta="right">
                  {formatCurrency(row.estCostUsd, { precise: true })}
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    </Stack>
  );
};
